var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"list"},_vm._l((50),function(item,index){return _c('img-text-row',{key:index})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }